var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"NoResultComp",class:{'darkMode':_vm.themeToDisplay=='dark'}},[_c('font-awesome-icon',{staticClass:"icon ",attrs:{"icon":_vm.fontAwesomeIcon}}),_c('div',{staticClass:"text"},[_vm._v(_vm._s(_vm.text))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }